import { Controller } from "stimulus"
import config from "../../js/siteConfig"

export default class NavController extends Controller {
  static get values() {
    return { show: Boolean }
  }

  static get targets() {
    return ["worksItem", "navToggle", "popupLink", "popup", "works", "language"]
  }

  connect() {
    this.animateTimeout = 0
    this.showValue = false
  }

  toggleWorksDropdown() {
    this.worksItemTarget.classList.toggle("selected")
  }

  toggleNav(e) {
    if (e.target == e.currentTarget) {
      this.showValue = !this.showValue
      this.navToggleTarget.classList.toggle("close")
    }
  }
  /**
   * Show/hide and animate the sidebar on mobile view
   */
  showValueChanged() {
    if (this.showValue) {
      clearTimeout(this.animateTimeout)
      this.element.classList.add("animate")
      this.element.classList.add("show")
    } else {
      this.animateTimeout = setTimeout(() => {
        this.element.classList.remove("animate")
      }, 500)
      this.element.classList.remove("show")
    }
  }

  // switch language
  switchLocale(e) {
    e.preventDefault()
    const l = e.currentTarget.dataset.lang
    let href = document.location.href
      .split("/")
      .splice(0, 5)
      .map((s) => (Object.keys(config.LOCALES).indexOf(s) > -1 ? l : s))
      .join("/")

    // if location is the siteroot
    if (href.indexOf(l) === -1) href += `${l}/`

    document.location.href = href
  }

  // show a popup
  togglePopup(e) {
    e.preventDefault()

    const popup = this[`${e.currentTarget.dataset.popup}Target`]

    this.hidePopups(null, popup)
    popup.classList.toggle("is-visible")

    popup.removeAttribute("style")
    const rect = e.currentTarget.getBoundingClientRect()

    popup.style.top = `${Math.round(rect.y + rect.height + 4)}px`
    if (popup.classList.contains("align-right")) {
      popup.style.left = `${Math.round(rect.x + rect.width)}px`
    } else {
      popup.style.left = `${Math.round(rect.x)}px`
    }
  }

  // hide all popups that are opened and visible
  hidePopups(e, elementToExclude) {
    // listening on the click of event of the document object
    // to check if the click was outside of any open panels and their opening links
    if (e && e.type == "click" && e.target && this.element.querySelectorAll(".nav__popup.is-visible").length > 0) {
      let clickoutside = true

      this.element.querySelectorAll(".nav__popup.is-visible").forEach((el) => {
        // check if the click comes from outside of any open popups
        if (clickoutside && (el === e.target || el.contains(e.target))) {
          clickoutside = false
        }

        // check then if the click is coming from the popupLink associated with any open popups
        if (clickoutside) {
          this.popupLinkTargets.forEach((link) => {
            if (
              el === this[`${link.dataset.popup}Target`] && // identifying the link that opens the popup
              (link === e.target || link.contains(e.target)) // checking if the target is that link or a child of it
            ) {
              clickoutside = false
            }
          })
        }
      })

      // if the click was not a clickoutside return so we don't change anything
      if (!clickoutside) return
    }

    this.element.querySelectorAll(".nav__popup.is-visible").forEach((popup) => {
      if (!elementToExclude || elementToExclude !== popup) {
        popup.classList.remove("is-visible")
      }
    })
  }
}
